export const getSurveillance = state => state.surveillance.data
export const isSurveillanceLoading = state => state.surveillance.loading
export const getExpirationDate = state => state.surveillance.expirationDate
